<template>
	<div>
		<div style="text-align: right; padding-bottom: 20px;">
			<el-link type="primary" @click="exportXls">导出XLS</el-link>
		</div>
		<table id="table" class="datatable" cell-spacing="1" cell-padding="100">
			<tr>
				<td :colspan="2 + areaList.length"> {{ year }}年五年制高职教育计划完成情况及生源质量统计表</td>

			</tr>
			<tr>

				<td>分院<br />（办学点）</td>
				<td colspan="areaList.length>3?3:2">{{ schoolname }}</td>
				<td>填表人</td>
				<td :colspan="areaList.length>3?(areaList.length - 3):2">{{ teacherInfo.username }}</td>
			</tr>

			<tr>

				<td :colspan="areaList.length>3?4:3"></td>


				<td>电话</td>
				<td :colspan="areaList.length - 1">{{ teacherInfo.phone }}</td>
			</tr>
			<tr>
				<td></td>
				<td>总计</td>
				<td v-for="(a, i) in areaList" :key="i">{{ a.area_name }}</td>


			</tr>
			<tr>
				<td>计划数</td>
				<td>{{ zs_all1 }}</td>

				<td v-for="(a, i) in areaList" :key="i">{{ a.total }}</td>


			</tr>
			<tr>
				<td>实际招生数</td>
				<td>{{ zs_all2 }}</td>

				<td v-for="(a, i) in areaList" :key="i" style="color:blue;font-weight: bolder;">{{ a.zs_total }}</td>

			</tr>

			<tr v-if="areaScore">
				<td colspan="2">中考总分</td>

				<td v-for="(a, i) in areaList" :key="i">{{ areaScore[a.area_name].total_score }}</td>


			</tr>

			<tr v-if="areaScore">
				<td colspan="2" rowspan="2">中考总分<br />80%以上<br />分数段人数</td>

				<td v-for="(a, i) in areaList" :key="i">{{ getScore(areaScore[a.area_name].total_score * 0.8) }}分及以上
				</td>
			</tr>
			<tr v-if="areaScore">
				<td v-for="(a, i) in areaList" :key="i" style="color:blue;font-weight: bolder;">{{ getScore(areaScore[a.area_name].steps[0].count) }}</td>
			</tr>

			<tr v-if="areaScore">
				<td colspan="2" rowspan="2">中考总分<br />75%-80%<br />分数段人数</td>

				<td v-for="(a, i) in areaList" :key="i">
					{{ getScore(areaScore[a.area_name].total_score * 0.75) }}-{{
							getScore(areaScore[a.area_name].total_score * 0.8)
					}}
				</td>
			</tr>
			<tr v-if="areaScore">
				<td v-for="(a, i) in areaList" :key="i"  style="color:blue;font-weight: bolder;">{{ getScore(areaScore[a.area_name].steps[1].count) }}</td>
			</tr>
			<tr v-if="areaScore">
				<td colspan="2" rowspan="2">中考总分<br />70%-75%<br />分数段人数</td>

				<td v-for="(a, i) in areaList" :key="i">
					{{ getScore(areaScore[a.area_name].total_score * 0.7) }}-{{
							getScore(areaScore[a.area_name].total_score * 0.75)
					}}
				</td>
			</tr>
			<tr v-if="areaScore">
				<td v-for="(a, i) in areaList" :key="i" style="color:blue;font-weight: bolder;">{{ getScore(areaScore[a.area_name].steps[2].count) }}</td>
			</tr>
			<tr v-if="areaScore">
				<td colspan="2" rowspan="2">中考总分<br />65%-70%<br />分数段人数</td>

				<td v-for="(a, i) in areaList" :key="i">
					{{ getScore(areaScore[a.area_name].total_score * 0.65) }}-{{
							getScore(areaScore[a.area_name].total_score * 0.7)
					}}
				</td>
			</tr>
			<tr v-if="areaScore">
				<td v-for="(a, i) in areaList" :key="i" style="color:blue;font-weight: bolder;">{{ getScore(areaScore[a.area_name].steps[3].count) }}</td>
			</tr>

			<tr v-if="areaScore">
				<td colspan="2" rowspan="2">中考总分<br />60%-65%<br />分数段人数</td>

				<td v-for="(a, i) in areaList" :key="i">
					{{ getScore(areaScore[a.area_name].total_score * 0.6) }}-{{
							getScore(areaScore[a.area_name].total_score * 0.65)
					}}
				</td>
			</tr>
			<tr v-if="areaScore">
				<td v-for="(a, i) in areaList" :key="i" style="color:blue;font-weight: bolder;">{{ getScore(areaScore[a.area_name].steps[4].count) }}</td>
			</tr>


			<tr v-if="areaScore">
				<td colspan="2" rowspan="2">中考总分<br />55%-60%<br />分数段人数</td>

				<td v-for="(a, i) in areaList" :key="i">
					{{ getScore(areaScore[a.area_name].total_score * 0.55) }}-{{
							getScore(areaScore[a.area_name].total_score * 0.6)
					}}
				</td>
			</tr>
			
			<tr v-if="areaScore">
				<td v-for="(a, i) in areaList" :key="i" style="color:blue;font-weight: bolder;">{{ getScore(areaScore[a.area_name].steps[5].count) }}</td>
			</tr>
			<tr v-if="areaScore&&$store.state.pmid==20">
				<td colspan="2" rowspan="2">中考总分<br />50%-55%<br />分数段人数</td>

				<td v-for="(a, i) in areaList" :key="i">
					{{ getScore(areaScore[a.area_name].total_score * 0.50) }}-{{
							getScore(areaScore[a.area_name].total_score * 0.55)
					}}
				</td>
			</tr>
			<tr v-if="areaScore&&$store.state.pmid==20">
				<td v-for="(a, i) in areaList" :key="i" style="color:blue;font-weight: bolder;">{{ getScore(areaScore[a.area_name].steps[6].count) }}</td>
			</tr>
			<tr v-if="areaScore&&$store.state.pmid==20">
				<td colspan="2" rowspan="2">中考总分<br />45%-50%<br />分数段人数</td>

				<td v-for="(a, i) in areaList" :key="i">
					{{ getScore(areaScore[a.area_name].total_score * 0.45) }}-{{
							getScore(areaScore[a.area_name].total_score * 0.50)
					}}
				</td>
			</tr>
			<tr v-if="areaScore&&$store.state.pmid==20">
				<td v-for="(a, i) in areaList" :key="i" style="color:blue;font-weight: bolder;">{{ getScore(areaScore[a.area_name].steps[7].count) }}</td>
			</tr>
			<tr v-if="areaScore&&$store.state.pmid==20">
				<td colspan="2" rowspan="2">中考总分<br />低于45%<br />分数段人数</td>

				<td v-for="(a, i) in areaList" :key="i">
					{{ getScore(areaScore[a.area_name].total_score * 0) }}-{{
							getScore(areaScore[a.area_name].total_score * 0.45)
					}}
				</td>
			</tr>
			<tr v-if="areaScore&&$store.state.pmid==20">
				<td v-for="(a, i) in areaList" :key="i" style="color:blue;font-weight: bolder;">{{ getScore(areaScore[a.area_name].steps[8].count) }}</td>
			</tr>


			<!-- <tr v-for="(m,j) in majorList" :key="j">
			<td>{{m.zs_count}}</td>
				<td>{{m.zs_count}}</td>
				<td v-for="(a,i) in areaList" :key="i">{{m.majors[a.area_name]?m.majors[a.area_name].plan.num:0}}</td>
				
			</tr> -->
		</table>

		<div style="height: 50px;"></div>

	</div>
</template>

<script>
import XLSX from 'xlsx'
export default {

	data() {
		return {
			areaList: [],
			majorList: [],
			zs_all1: 0,
			zs_all2: 0,
			schoolname: "",
			teacherInfo: JSON.parse(sessionStorage.getItem("userinfo")),
			areaScore: null,
			year: localStorage.getItem("year")
		}
	},
	mounted() {
		this.getData()
		this.getAreaScore()
		this.$http.post("/api/app_platform_info").then(app => {

			this.schoolname = app.data.platform
		})
	},
	methods: {
		getData() {
			this.$http.post('/api/sch_area_major_plan', { only5year: this.$store.state.pmid == 20 ? 1 : 0 }).then(res => {
				let areaList = [];
				for (let p of res.data.area) {
					if (this.$store.state.pmid != 20) {
						if (p.area_name.indexOf("江苏") >= 0) {
							areaList = p.children

						} 
					}else {
							if (p.area_name) {
								areaList = areaList.concat(p.children)

							}
						}
				}
				let majors = [];
				let zs_all1 = 0,
					zs_all2 = 0;;
				for (let yx of res.data.major) {
					for (let m of yx.children) {
						m.majors = []
						m.zs_count = 0;
						for (let p of m.area) {
							for (let c of p.children) {
								m.majors[c.area_name] = c
								m.zs_count += c.plan.num
								zs_all1 += c.plan.num
							}
						}
						majors.push(m)
					}
				}
				console.log(majors)
				this.majorList = majors;
				for (let a of areaList) {
					for (let m of majors) {
						if (!a['total']) {
							a['total'] = m.majors[a.area_name].plan.num
						} else {
							a['total'] += m.majors[a.area_name].plan.num
						}

						if (!a['zs_total']) {
							a['zs_total'] = m.majors[a.area_name].zs_count
						} else {
							a['zs_total'] += m.majors[a.area_name].zs_count
						}
						zs_all2 += m.majors[a.area_name].zs_count
					}
				}
				this.areaList = areaList
				this.zs_all1 = zs_all1
				this.zs_all2 = zs_all2

			})
		},
		getAreaScore() {
			this.$http.post("/api/sch_areascore_tree").then(res => {
				let areaScore = {}
				for (let p of res.data) {
					for (let c of p.children) {
						areaScore[c.area_name] = c
					}
				}

				this.$http.post("/api/sch_area_students",{ only5year: this.$store.state.pmid == 20 ? 1 : 0}).then(res => {
					for (let a of res.data) {
						for (let c in areaScore) {
							if (a.area_name.indexOf(c) >= 0) {
								//areaScore[c].students = a.students;

								//80以上
								let score1 = {
									pmax: 0.8,
									pmin: 0.8,
									count: 0
								},
									score2 = {
										pmax: 0.8,
										pmin: 0.75,
										count: 0
									},
									score3 = {
										pmax: 0.75,
										pmin: 0.7,
										count: 0
									},
									score4 = {
										pmax: 0.7,
										pmin: 0.65,
										count: 0
									},
									score5 = {
										pmax: 0.65,
										pmin: 0.6,
										count: 0
									},
									score6 = {
										pmax: 0.6,
										pmin: 0.55,
										count: 0
									},
									score7 = {
										pmax: 0.55,
										pmin: 0.5,
										count: 0
									},
									score8 = {
										pmax: 0.5,
										pmin: 0.45,
										count: 0
									},
									score9 = {
										pmax: 0.45,
										pmin: 0,
										count: 0
									}

								for (let stu of a.students) {

									if (stu.exam_score >= areaScore[c].total_score * score1.pmin) {
										score1.count++
									} else if (stu.exam_score >= areaScore[c].total_score * score2
										.pmin && stu.exam_score < areaScore[c].total_score * score2
											.pmax) {
										score2.count++
									} else if (stu.exam_score >= areaScore[c].total_score * score3
										.pmin && stu.exam_score < areaScore[c].total_score * score3
											.pmax) {
										score3.count++
									} else if (stu.exam_score >= areaScore[c].total_score * score4
										.pmin && stu.exam_score < areaScore[c].total_score * score4
											.pmax) {
										score4.count++
									} else if (stu.exam_score >= areaScore[c].total_score * score5
										.pmin && stu.exam_score < areaScore[c].total_score * score5
											.pmax) {
										score5.count++
									} else if (stu.exam_score >= areaScore[c].total_score * score6
										.pmin && stu.exam_score < areaScore[c].total_score * score6
											.pmax) {
										score6.count++
									}else if (stu.exam_score >= areaScore[c].total_score * score7
										.pmin && stu.exam_score < areaScore[c].total_score * score7
											.pmax) {
										score7.count++
									}else if (stu.exam_score >= areaScore[c].total_score * score8
										.pmin && stu.exam_score < areaScore[c].total_score * score8
											.pmax) {
										score8.count++
									}else if (stu.exam_score >= areaScore[c].total_score * score9
										.pmin && stu.exam_score < areaScore[c].total_score * score9
											.pmax) {
										score9.count++
									}
								}

								areaScore[c].steps = [score1, score2, score3, score4, score5, score6, score7, score8,score9]
							}
						}

					}

					this.areaScore = areaScore
					console.log(areaScore)
				})


			})
		},
		getScore(score) {
			return parseInt(score)
		},
		exportXls() {
			let workbook = XLSX.utils.table_to_book(document.getElementById('table'))
			try {
				XLSX.writeFile(workbook, '高职教育计划完成情况及生源质量统计表' + parseInt(Math.random() * 10000) + '.xlsx');
			} catch (e) {
				console.log(e, workbook);
			}
		}

	},
}
</script>

<style scoped="scoped">
.datatable {
	background-color: #E4E7ED;
	width: 100%;
}

.datatable td {
	background-color: #fff;
	text-align: center;
	padding: 10px 0;
}
</style>
